import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import PermanentRecruitment from "@/pages/PermanentRecruitment";
import ContractStaffing from "@/pages/ContractStaffing";
import Rpo from "@/pages/Rpo";
import PayrollManagement from "@/pages/PayrollManagement";
import CurrentOpenings from "@/pages/CurrentOpenings";
import ApplyHere from "@/pages/ApplyHere";
import DiscussRequirement from "@/pages/DiscussRequirement";
import HowGenspireWorks from "@/pages/HowGenspireWorks";
import Contact from "@/pages/Contact";
import AdminInbox from "@/pages/AdminInbox";
import Legal from "@/pages/Legal";

function ScrollManager() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    const lenis = window.__lenis;
    if (hash) {
      const t = setTimeout(() => {
        const el = document.getElementById(hash.slice(1));
        if (el && lenis) lenis.scrollTo(el, { offset: -96 });
        else if (el) el.scrollIntoView();
      }, 80);
      return () => clearTimeout(t);
    }
    if (lenis) lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <BrowserRouter>
      <ScrollManager />
      <div className="min-h-screen bg-white">
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/permanent-recruitment" element={<PermanentRecruitment />} />
            <Route path="/services/contract-staffing" element={<ContractStaffing />} />
            <Route path="/services/rpo" element={<Rpo />} />
            <Route path="/services/payroll-management" element={<PayrollManagement />} />
            <Route path="/careers/openings" element={<CurrentOpenings />} />
            <Route path="/careers/apply" element={<ApplyHere />} />
            <Route path="/discuss-your-requirement" element={<DiscussRequirement />} />
            <Route path="/how-genspire-works" element={<HowGenspireWorks />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/admin/inbox" element={<AdminInbox />} />
            <Route path="/privacy" element={<Legal title="Privacy Policy" />} />
            <Route path="/terms" element={<Legal title="Terms & Conditions" />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
        <Footer />
      </div>
      <Toaster position="top-center" richColors />
    </BrowserRouter>
  );
}

export default App;
